var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_6492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.07129 3.75H13.9284",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67871 3.75H12.3216V13.3929C12.3216 13.677 12.2086 13.9496 12.0077 14.1505C11.8069 14.3514 11.5343 14.4643 11.2501 14.4643H3.75014C3.46598 14.4643 3.19346 14.3514 2.99252 14.1505C2.7916 13.9496 2.67871 13.677 2.67871 13.3929V3.75Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82129 3.74944V3.21373C4.82129 2.50333 5.10349 1.82202 5.60582 1.31969C6.10815 0.817362 6.78946 0.535156 7.49986 0.535156C8.21026 0.535156 8.89157 0.817362 9.3939 1.31969C9.89623 1.82202 10.1784 2.50333 10.1784 3.21373V3.74944",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89258 6.96484V11.2522",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10742 6.96484V11.2522",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_6492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.04290d008d399ccd1622873e3b84c1b8.svg";
export { ForwardRef as ReactComponent };